/**
 * Feature flags configuration
 * Features can be enabled/disabled via environment variables
 */

export const features = {
  /**
   * Enable/disable the Tasks feature
   * Set REACT_APP_ENABLE_TASKS=true to enable, false or unset to disable
   */
  tasks: process.env.REACT_APP_ENABLE_TASKS === 'true',
} as const;

/**
 * Type-safe feature flag checker
 */
export const isFeatureEnabled = (feature: keyof typeof features): boolean => {
  return features[feature];
};
